module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"realizado_por":"Realizado por ","para_el":" para el "},"en":{"realizado_por":"Made by ","para_el":" for "}}')
  delete Component.options._Ctor
}
